import React from 'react'
import { useMount } from 'react-nb-hooks'

const DetailsChecker = ({ shouldCheck, doCheck, renderCheckResult, children }) => {
  const [isFetching, setFetching] = React.useState(false)
  const [isDetailsVisible, setVisibility] = React.useState(!shouldCheck)

  const loadData = React.useCallback(
    async (isMount = true) => {
      setFetching(true)

      try {
        await doCheck(isMount)
      } catch (error) {
        console.error(error)
      } finally {
        setFetching(false)
      }
    },
    [setFetching, doCheck],
  )

  useMount(() => {
    if (shouldCheck) {
      loadData()
    }
  })

  return (
    <>
      {renderCheckResult({ isFetching, onRecheck: () => loadData(false), onClose: () => setVisibility(true) })}
      {isDetailsVisible && children}
    </>
  )
}

export default React.memo(DetailsChecker)
